import { api } from '@/fsd/shared/api';
import { IFavoriteSection } from '../model/types/IFavoriteSection';

export const getFavoriteSections = async (): Promise<IFavoriteSection[]> => {
  const data = await api.get<IFavoriteSection[]>(
    `/api/v1/general/favorite/section/`
  );

  return data;
};
